import PropTypes from 'prop-types'

import defaultAdvisorAvatar from '../../../../../shared_assets/default-advisor-avatar.svg'

const FuneralHomeContactCard = ({advisorImageUrl, firmLogoUrl, firmName}) => {
  let imageAltText

  if (firmLogoUrl)
    imageAltText = `${firmName} logo`
  else if (advisorImageUrl)
    imageAltText = `${firmName} advisor photo`
  else
    imageAltText = `${firmName} default profile image`

  const imageUrl = firmLogoUrl || advisorImageUrl || defaultAdvisorAvatar

  return (
    <div className='funeral-home-contact-card'>
      {firmName && <div className='funeral-home-name'>{firmName}</div>}
      <img alt={imageAltText} className={firmLogoUrl ? 'funeral-home-logo' : null} src={imageUrl} />
    </div>
  )
}

FuneralHomeContactCard.propTypes = {
  advisorImageUrl: PropTypes.string,
  firmLogoUrl: PropTypes.string,
  firmName: PropTypes.string.isRequired
}

export default FuneralHomeContactCard
